import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CalendlyFab from '../../components/CalendlyFab';

const Framework = () => (
  <div className="bg-dark min-vh-100">
    <Container className="py-5">
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold mb-3 text-light">🚀 Automation Framework</h1>
        <p className="lead text-warning fw-bold">Empowering Quality Through Intelligent Automation</p>
        <div className="text-center mt-4">
          <Link to="/klassitech" className="btn btn-outline-warning">
            <i className="bi bi-arrow-left me-2"></i>
            Back to KlassiTech
          </Link>
        </div>
        <div>
          <p></p>
        </div>
        <p className="text-light mb-3">
          At the core of our quality assurance strategy is a powerful, scalable, and intelligent test automation framework —
            <a
              href="https://github.com/klassijs/klassi-js"
              target="_blank"
              rel="noopener noreferrer"
              className="fw-bold text-warning ms-1"
            > Klassi-JS.  </a>
              Built on modern open-source technologies like WebdriverIO and Cucumber.js, Klassi-JS enables behavior-driven development (BDD) and delivers reliable, efficient, and maintainable automated testing solutions.
        </p>
      </div>

      <Row className="g-4 mb-5 justify-content-center">
        <Col xs={12} md={6} lg={5}>
          <Card className="h-100 bg-dark-subtle border-warning shadow">
            <Card.Body>
              <h4 className="text-light fw-bold mb-4">🧠 Why Klassi-JS?</h4>
              {/*<Card.Title className="text-light fw-bold mb-4">🧠 Why Klassi-JS?</Card.Title>*/}
              {/*<Card.Title className="text-warning h4 mb-3">🧠 Why Klassi-JS?</Card.Title>*/}
              <ul className="text-primary mb-0">
                <li className="mb-2"><b>Behavior-Driven Development (BDD):</b> Clear, human-readable test scenarios that bridge the gap between business and technical teams.</li>
                <li className="mb-2"><b>Cross-platform Testing:</b> Seamless execution across web, mobile, and API layers.</li>
                <li className="mb-2"><b>AI-enhanced Debugging:</b> Smart diagnostics that reduce time spent on test failures.</li>
                <li className="mb-2"><b>Cloud Integration:</b> Scalable test execution on platforms like BrowserStack, LambdaTest, and AWS.</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={6} lg={5}>
          <Card className="h-100 bg-dark-subtle border-warning shadow">
            <Card.Body>
              <h4 className="text-light fw-bold mb-4">🛠️ Framework Highlights</h4>
              {/*<Card.Title className="text-light fw-bold mb-4">🛠️ Framework Highlights</Card.Title>*/}
              {/*<Card.Title className="text-warning h4 mb-3">🛠️ Framework Highlights</Card.Title>*/}
              <ul className="text-primary mb-0">
                <li className="mb-2"><b>Modular Architecture:</b> Clean separation of concerns using page objects and shared utilities.</li>
                <li className="mb-2"><b>Multi-type Testing:</b> Functional, API, accessibility, and visual testing in one unified framework.</li>
                <li className="mb-2"><b>CI/CD Ready:</b> Fully integrated with our DevOps pipelines for continuous testing.</li>
                <li className="mb-2"><b>Rich Reporting:</b> Real-time dashboards and detailed HTML reports for actionable insights.</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-5 justify-content-center">
        <Col xs={12} md={10} lg={8}>
          <Card className="bg-dark-subtle border-warning shadow">
            <Card.Body>
              <h4 className="text-light fw-bold mb-4">📁 Project Structure</h4>
              {/*<Card.Title className="text-light fw-bold mb-4">📁 Project Structure</Card.Title>*/}
              <pre className="bg-dark text-light rounded p-3 mb-0" style={{ fontSize: '1rem' }}>
{`├── features/           # Gherkin feature files
├── page-objects/       # Page Object Models
├── shared-objects/     # Reusable data and utilities
├── step_definitions/   # Step implementations
└── reports/            # Auto-generated test reports`}
              </pre>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-5 justify-content-center">
        <Col xs={12} md={10} lg={8}>
          <Card className="bg-dark-subtle border-warning shadow">
            <Card.Body>
              <h4 className="text-light fw-bold mb-4">🌐 Real-World Impact</h4>
              {/*<Card.Title className="text-light fw-bold mb-4">🌐 Real-World Impact</Card.Title>*/}
              <ul className="text-primary mb-0">
                <li className="mb-2">Reduced regression testing time by <b>60%</b></li>
                <li className="mb-2">Increased test coverage across browsers and devices</li>
                <li className="mb-2">Improved collaboration between QA, developers, and product teams</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="text-center mt-4">
        <Link to="/klassitech" className="btn btn-outline-warning">
          <i className="bi bi-arrow-left me-2"></i>
          Back to KlassiTech
        </Link>
      </div>

      <CalendlyFab />
    </Container>
  </div>
);

export default Framework;